import React, { useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

export const HighRiskToggle = ({ medication, handleChange, readonly }) => {
  const [active, setActive] = useState(!!medication.highriskindicated);

  const handleClick = () => {
    if (!readonly) {
      const newActive = !active;
      setActive(newActive);
      handleChange(medication, 'highriskindicated', newActive, {
        skipRefresh: true,
      });
    }
  };

  return (
    <Tooltip title="High Risk Indicator">
      <span>
        <IconButton size="small" onClick={handleClick} disabled={readonly}>
          <WarningIcon
            fontSize="small"
            htmlColor={active ? '#f9a825' : '#c5c1c1ff'}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
};
